import { useState } from 'react';
import { Modal } from '@/components/molecules';
import { PurchaseOrderList, PurchaseOrderForm } from '@/components/organisms/PurchaseOrder';

export default function PurchaseOrdersPage() {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const handleCreateSuccess = () => {
    setIsCreateModalOpen(false);
  };

  return (
    <div className="space-y-6">
      <PurchaseOrderList onCreateClick={() => setIsCreateModalOpen(true)} />

      <Modal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        title="Create Purchase Order"
        size="lg"
      >
        <PurchaseOrderForm
          onSuccess={handleCreateSuccess}
          onCancel={() => setIsCreateModalOpen(false)}
        />
      </Modal>
    </div>
  );
}
